
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["checkmark",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 52 52"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"26","cy":"26","r":"25","fill":"none"}}),_c('path',{attrs:{"fill":"none","d":"M14.1 27.2l7.1 7.2 16.7-16.8"}})])
          )
        }
      }
    